import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, Link, useNavigate } from "react-router-dom";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";
import logo from "../../logo.jpg";
import { Dropdown, Image } from "react-bootstrap";

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const location = useLocation();

  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [userRole, setUserRole] = useState(null);
  const [userName, setUserName] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleLogin = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);

      if (token) {
        GetProfile.get()
          .then((response) => {
            setUserRole(response.userRole);
            setProfile(response);
            setUserName(
              i18n.language === "ar"
                ? response.arabicFullName
                : response.englishFullName
            );
            setProfileImage(response.profileImage || "");
          })
          .catch((error) => {
            console.error("خطأ في جلب بيانات المستخدم:", error);
          });
      }
    };

    handleLogin();

    window.addEventListener("user-logged-in", handleLogin);

    return () => {
      window.removeEventListener("user-logged-in", handleLogin);
    };
  }, []);

  useEffect(() => {
    if (profile) {
      setUserName(
        i18n.language === "ar"
          ? profile.arabicFullName
          : profile.englishFullName
      );
    }
  }, [i18n.language, profile]);

  const handleLanguageChange = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/login");
  };

  // دالة لتبديل حالة القائمة المنسدلة
  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  useEffect(() => {
    // عند تغيّر المسار، أغلق القائمة
    setIsNavbarOpen(false);
  }, [location]);

  useEffect(() => {
    const closeNavbar = () => {
      setIsNavbarOpen(false);
    };

    // أغلق القائمة عند التنقل بين الصفحات
    window.addEventListener("popstate", closeNavbar);

    return () => {
      window.removeEventListener("popstate", closeNavbar);
    };
  }, []);

  return (
    <header dir={languageDirection}>
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand fw-bold text-primary-custom" to="/">
            <img
              src={logo}
              alt={t("footer_logo_alt")}
              style={{ maxHeight: "95px", width: "auto" }}
              className="img-fluid"
            />
          </Link>

          <button
            className={`navbar-toggler ${isNavbarOpen ? "" : "collapsed"}`}
            type="button"
            onClick={() => setIsNavbarOpen((prev) => !prev)}
            aria-controls="navbarNav"
            aria-expanded={isNavbarOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`}
            id="navbarNav"
          >
            {" "}
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item me-1">
                <Link className="nav-link" to="/">
                  {t("home")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/speakers">
                  {t("speakers")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/events">
                  {t("events")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/news">
                  {t("News")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/blogs">
                  {t("blogs")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/map">
                  {t("map")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/about">
                  {t("about_us.title")}
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link className="nav-link" to="/contact">
                  {t("contact")}
                </Link>
              </li>
            </ul>
            <div className="d-flex align-items-center gap-2">
              {/* اللغة */}
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleLanguageChange}
              >
                <i className="fas fa-globe me-1"></i>
                {i18n.language === "ar" ? "EN" : "AR"}
              </button>

              {/* إذا كان مسجل دخول */}
              {isLoggedIn ? (
                <Dropdown
                  className={
                    i18n.language === "ar" ? "dropdown-rtl" : "dropdown-ltr"
                  }
                  show={dropdownOpen}
                  // onToggle={toggleDropdown}
                  ref={dropdownRef}
                >
                  <Dropdown.Toggle
                    variant="outline-primary"
                    id="user-dropdown"
                    className="d-flex align-items-center"
                    onClick={toggleDropdown}
                  >
                    {profileImage && (
                      <Image
                        src={profileImage}
                        alt="User"
                        roundedCircle
                        width="30"
                        height="30"
                        className="me-2"
                      />
                    )}
                    {userName && <span>{userName}</span>}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      disabled
                      className="d-flex align-items-center"
                    >
                      <i className="fas fa-user-tag me-2 text-muted"></i>
                      <span className="me-2 text-muted">
                        {t("accountTypeLabel")}:
                      </span>
                      <span className="fw-bold text-primary">
                        {userRole === 1 && t("accountTypes.user")}
                        {userRole === 3 && t("accountTypes.speaker")}
                        {userRole === 4 && t("accountTypes.organizer")}
                        {userRole === 2 && t("accountTypes.Administrator")}
                      </span>
                    </Dropdown.Item>
                    <Dropdown.Divider />

                    {userRole !== 2 && (
                      <>
                        <Dropdown.Item as={Link} to="/profile-edit">
                          <i className="fas fa-edit me-2"></i>{" "}
                          {t("profileEdit")}
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/my-favorites">
                          <i className="fas fa-heart me-2"></i>{" "}
                          {t("my_favorites")}
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/followers">
                          <i className="fas fa-user-friends me-2"></i>{" "}
                          {t("followers_following")}
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/account-settings">
                          <i className="fas fa-cog me-2"></i>{" "}
                          {t("AccountSettings")}
                        </Dropdown.Item>
                      </>
                    )}

                    {userRole === 2 && (
                      <>
                        <Dropdown.Item
                          as={Link}
                          to="/dashboard/industry-management"
                        >
                          <i className="fas fa-tachometer-alt me-2"></i>{" "}
                          {t("control_panel")}
                        </Dropdown.Item>
                      </>
                    )}

                    {userRole === 3 && (
                      <>
                        <Dropdown.Item as={Link} to="/my-content_management">
                          <i className="fas fa-book me-2"></i> {t("my_content")}
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} to="/received-invitations">
                          <i className="fas fa-envelope-open-text me-2"></i>
                          {t("my_invitations")}
                        </Dropdown.Item>
                      </>
                    )}

                    {userRole === 4 && (
                      <Dropdown.Item as={Link} to="/organizer-events">
                        <i className="fas fa-calendar-alt me-2"></i>{" "}
                        {t("OrganizerEvents")}
                      </Dropdown.Item>
                    )}

                    <Dropdown.Divider />
                    <Dropdown.Item
                      onClick={handleLogout}
                      className="text-danger"
                    >
                      <i className="fas fa-sign-out-alt me-2"></i> {t("logout")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <>
                  <Link to="/login" className="btn btn-outline-primary">
                    {t("login.title")}
                  </Link>

                  <Link to="/signup" className="btn btn-outline-primary">
                    {t("signup")}
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
